<template>
  <li>
    <div class="context-menu-toggle" :data-testid="getDataTestId(props.title)">
      <FormKit type="toggle" v-model="model" :label="props.title" @change="(event: Event, value: boolean) => $emit('update:modelValue', value)" :data-testid="getDataTestId(`toggle-${props.title}`)" />
    </div>
  </li>
</template>
<script setup lang="ts">
import { getDataTestId } from './ItemsHelper';

export interface MenuToggleProps {
  title: string;
  onChange?: string;
  subtitle?: string;
  disabled?: boolean;
  isToggle?: boolean;
}

const props = defineProps<MenuToggleProps>();
const model = defineModel({ default: false });
</script>

<style scoped>
.formkit-outer {
  @apply mb-0 hover:bg-slate-100 dark:hover:bg-zinc-700 active:bg-slate-300 dark:text-zinc-300 dark:hover:text-zinc-300 focus-visible:ring focus-visible:ring-blue-500/50 focus-visible:bg-blue-500/10 focus:outline-none;
}
</style>

<style>
.context-menu-toggle .formkit-outer .formkit-wrapper {
  @apply mb-0 gap-2 px-2 py-[0.625rem] relative z-20;
}

.context-menu-toggle .formkit-outer .formkit-wrapper label {
  @apply mb-0 mr-0;
}

.context-menu-toggle .formkit-outer .formkit-wrapper label::before {
  @apply content-[''] absolute inset-0 -z-10 hover:bg-slate-100 dark:hover:bg-zinc-700;
}

/* Override formkit-inner margin */
.context-menu-toggle .formkit-wrapper .inline-block {
  @apply !mr-0;
}

/* Override toggle input width and height to be 24px × 14px (1.5rem × 0.875rem) */
.context-menu-toggle input.toggle-switch {
  @apply !w-6 !h-3.5;
}

/* Override toggle thumb (::after pseudo-element) to be smaller and centered */
.context-menu-toggle input.toggle-switch::after {
  @apply !w-2.5 !h-2.5 !top-0.5 !left-0.5;
}

/* Adjust checked state positioning */
.context-menu-toggle input.toggle-switch:checked::after {
  @apply !left-auto !right-0.5;
}
</style>
